import dayjs from "dayjs";
import type { Dayjs } from "dayjs";
import type { RangePickerProps } from "antd/es/date-picker";

const rangeBasePresets: RangePickerProps["presets"] = [
    {
        label: "Today",
        value: [dayjs().startOf("day"), dayjs().endOf("day")],
    },
    {
        label: "Yesterday",
        value: [dayjs().subtract(1, "day").startOf("day"), dayjs().subtract(1, "day").endOf("day")],
    },
];

// The options for the user for how many days they look back
const dayOffsets = [7, 15, 30, 60, 90];

// Create a label and date range for each option (7 Days, 30 Days, etc.)
const entries: RangePickerProps["presets"] = dayOffsets.map((x) => {
    return {
        label: `${x} Days`,
        value: [dayjs().subtract(x, "days").startOf("day"), dayjs()],
    };
});

/** Predefined ranges displayed at bottom of date picker (Today, 7 Days, etc.) */
export const rangePresets = [...rangeBasePresets, ...entries];

export const defaultRange: [Dayjs, Dayjs] = [dayjs().subtract(30, "days").startOf("day"), dayjs()];
